import { Badge } from '@repo/ui/src/components/ui/badge';
import { promotionRunState } from '../lib/adminFormat';

interface PromotionStatusBadgeProps {
  active: boolean;
  startsAt: string;
  endsAt: string;
}

/** Shared between PromotionsPage's table and PromotionDetailPage so the two
 *  labels can't drift apart. The actual ACTIVE/OFF/UPCOMING/EXPIRED logic
 *  lives in `promotionRunState` (a plain function, not a component). */
export function PromotionStatusBadge({ active, startsAt, endsAt }: PromotionStatusBadgeProps) {
  switch (promotionRunState(active, startsAt, endsAt)) {
    case 'OFF':
      return <Badge variant="destructive">Đã tắt</Badge>;
    case 'UPCOMING':
      return <Badge variant="secondary">Chưa bắt đầu</Badge>;
    case 'EXPIRED':
      return <Badge variant="muted">Đã hết hạn</Badge>;
    default:
      return <Badge variant="success">Đang chạy</Badge>;
  }
}
